import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import Vant from 'vant';
import '@vant/touch-emulator';
import IconFont from '@/components/icon-font.vue';
import { axios } from '@/utils/request';
import tools from '@/utils/tools';
import avatar from '@/components/avatar.vue';
import Loading from '@/components/Loading.vue';

const app = createApp(App);

app.config.globalProperties.$axios = axios;
app.config.globalProperties.$tools = tools;

app.component('icon-font', IconFont);
app.component('avatar', avatar);
app.component('Loading', Loading);
app.use(store).use(router).use(Vant).mount('#app');

if (!['development', 'production'].includes(process.env.VUE_APP_CURRENTMODE)) {
  (function () {
    let script = document.createElement('script');
    script.src = '/eruda.js';
    document.body.appendChild(script);
    script.onload = function () {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      eruda && eruda.init();
    };
  })();
}
